const getApiBaseUrl = (): string => {
  const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
  
  if (isDevelopment) {
    return 'http://localhost:8080/api';
  }
  
  return 'https://cs.fabbuilder.com/cs-app/form-builder/api';
};

export const API_BASE_URL = getApiBaseUrl();

/**
 * The CRM host — same origin the form-builder backend proxies to. The AI
 * service and the persona API are called straight from the browser (the form
 * URL already carries `crmJwtToken` for auth), so this needs to be known here
 * too, not only in the backend's `CRM_BASE_URL`.
 */
const getCrmBaseUrl = (): string =>
  (import.meta.env.VITE_CRM_BASE_URL || 'https://cs.fabbuilder.com').replace(/\/+$/, '');

export const CRM_BASE_URL = getCrmBaseUrl();

/** The AI service sits beside the CRM API, not under `/api/tenant`. */
export const FABAI_BASE_URL = `${CRM_BASE_URL}/cs-app/fabai/api`;
